"use client";

/**
 * Host shell for the Procore side-panel surface. A cross-site iframe in a
 * normal browser, so (unlike Office) there is no Office.js, MSAL, theme lock,
 * or history polyfill: just the lightweight context-capture provider plus the
 * client-side auth/connect gate.
 *
 * `ProcoreProvider` runs the postMessage `setup` handshake and writes the
 * captured context to the host-context store; `ProcoreAuthGate` withholds the
 * chat until the user has a Magnus session and a connected Procore connector
 * (passing through for the `/procore/*` bootstrap + popups).
 */
import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { ProcoreAuthGate } from "./procore-auth-gate";
import { ProcoreProvider } from "./procore-provider";
export function ProcoreShell(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ProcoreProvider><ProcoreAuthGate>{children}</ProcoreAuthGate></ProcoreProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}